module.exports = __webpack_public_path__ + "img/digital-gate-mask.e467c3fc.png";